import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import CardWithIcon from 'components/CardWithIcon/CardWithIcon';
import ThumbsUpIcon from 'assets/icons/thumbsup.svg?react';
import { TwButton } from 'components/TwButton/TwButton';
import H1 from 'components/H/H1';
import useUpsale from './useUpsale';
import UpsaleOffer from './UpsaleOffer';

export default function Upsale() {
  const { t } = useTranslation('upsale');
  const { handleAccept, handleChangeAmount, isLoading, isPending, offer } =
    useUpsale();

  return (
    <>
      <Helmet>
        <title>{t('html_title')}</title>
      </Helmet>

      <CardWithIcon
        data-test="upsaleCard"
        icon={<ThumbsUpIcon data-test="upsale-icon" />}
      >
        <div className="flex flex-col items-center gap-3 md:px-6">
          <H1 dataTest="upsaleCard-title">{t('card_title')}</H1>
          <p data-test="upsaleCard-text-1">{t('card_text1')}</p>
          <p data-test="upsaleCard-text-2-wrapper">
            {t('card_text2')}
            <span
              className="text-primary font-semibold"
              data-test="upsaleCard-text-3"
            >
              {t('card_text3')}
            </span>
            {t('card_text4')}
          </p>

          <div className="w-full pt-7 pb-8">
            <UpsaleOffer offer={offer} isLoading={isLoading} />
          </div>

          <div className="flex gap-4 w-full justify-center lg:justify-start flex-col lg:flex-row">
            <TwButton
              data-test="go-to-change-amount"
              onClick={handleAccept}
              pending={isPending}
              disabled={isPending || isLoading}
            >
              {t('button_change_amount')}
            </TwButton>
            <TwButton
              data-test="go-calculate-amount"
              onClick={handleChangeAmount}
              pending={isPending}
              disabled={isLoading || isPending}
              className={twMerge(
                'bg-transparent border ',
                isPending
                  ? 'text-primary-foreground border-border'
                  : 'text-primary border-primary',
              )}
            >
              {t('button')}
            </TwButton>
          </div>
        </div>
      </CardWithIcon>
    </>
  );
}
